module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Illinois PGA-cf2eacb6fd7cbc7b9a01dfbc9a8f5dfe.jpg";